import React from 'react';

import AgreementsTable from './AgreementsTable';

export default () => <AgreementsTable />;
